export const setAccountStore = payload => ({
    type: 'SET_ACCOUNT_STORE',
    payload,
});

export const toggleSyncing = () => ({
    type: 'ACCOUNT_TOGGLE_SYNCING',
});

export const toggleSyncingSuccess = isEnabled => ({
    type: 'ACCOUNT_TOGGLE_SYNCING_SUCCESS',
    isEnabled,
});

export const toggleSyncingError = error => ({
    type: 'ACCOUNT_TOGGLE_SYNCING_ERROR',
    error,
});

export const toggleAutoSyncing = () => ({
    type: 'ACCOUNT_TOGGLE_AUTO_SYNCING',
});

export const toggleAutoSyncingSuccess = isEnabled => ({
    type: 'ACCOUNT_TOGGLE_AUTO_SYNCING_SUCCESS',
    isEnabled,
});

export const toggleAutoSyncingError = error => ({
    type: 'ACCOUNT_TOGGLE_AUTO_SYNCING_ERROR',
    error,
});

export const reactivateAccount = () => ({
    type: 'REACTIVATE_ACCOUNT',
});

export const reactivateAccountSuccess = account => ({
    type: 'REACTIVATE_ACCOUNT_SUCCESS',
    account,
});

export const reactivateAccountError = error => ({
    type: 'REACTIVATE_ACCOUNT_ERROR',
    error,
});

export const deactivateAccount = () => ({
    type: 'DEACTIVATE_ACCOUNT',
});

export const deactivateAccountSuccess = account => ({
    type: 'DEACTIVATE_ACCOUNT_SUCCESS',
    account,
});

export const deactivateAccountError = error => ({
    type: 'DEACTIVATE_ACCOUNT_ERROR',
    error,
});

// Entering impersonation no longer goes through Redux — the `/impersonate`
// landing page exchanges the handoff token directly (M7-365). Only the exit
// flow remains an action (dispatched from the HeaderBar "Exit Impersonation").
export const exitImpersonateUser = () => ({
    type: 'EXIT_IMPERSONATE_USER',
});

export const impersonateStoreClear = () => ({
    type: 'IMPERSONATE_STORE_CLEAR',
});

// Migration-confidence sandbox signal. Dispatched by the masquerade saga
// when the backend response (or the sim-mode token flow) indicates the
// session is now operating inside a sandbox clone. Consumed by the
// `SimModeBanner` component and by any downstream selector that needs to
// short-circuit side effects that would otherwise reach external systems.
export const setSimMode = isActive => ({
    type: 'SET_SIM_MODE',
    payload: isActive === true,
});
